import { render } from "./ItemProfile.vue?vue&type=template&id=1a07a5c0&scoped=true"
import script from "./ItemProfile.vue?vue&type=script&lang=ts"
export * from "./ItemProfile.vue?vue&type=script&lang=ts"

import "./ItemProfile.vue?vue&type=style&index=0&id=1a07a5c0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1a07a5c0"

export default script